import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72006b81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "id fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "voting-status voting"
}
const _hoisted_4 = {
  key: 1,
  class: "voting-status rejected"
}
const _hoisted_5 = {
  key: 2,
  class: "voting-status accepted"
}
const _hoisted_6 = {
  key: 3,
  class: "voting-status deposit"
}
const _hoisted_7 = {
  key: 4,
  class: "voting-status failed"
}
const _hoisted_8 = { class: "middle" }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = { class: "voting-date" }
const _hoisted_11 = { class: "start-date" }
const _hoisted_12 = { class: "green-background" }
const _hoisted_13 = { class: "end-date" }
const _hoisted_14 = { class: "blue-background" }
const _hoisted_15 = { class: "chartbox" }
const _hoisted_16 = {
  style: {"height":"20px"},
  class: "chartdiv"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "T", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dots" }, null, -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1 /* HOISTED */))
const _hoisted_20 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Q", -1 /* HOISTED */))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dots" }, null, -1 /* HOISTED */))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vl" }, null, -1 /* HOISTED */))
const _hoisted_24 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "voting-result" }
const _hoisted_26 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot yes" }, null, -1 /* HOISTED */))
const _hoisted_28 = { class: "bar-legend" }
const _hoisted_29 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot abstain" }, null, -1 /* HOISTED */))
const _hoisted_31 = { class: "bar-legend" }
const _hoisted_32 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot no" }, null, -1 /* HOISTED */))
const _hoisted_34 = { class: "bar-legend" }
const _hoisted_35 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot no-with-veto" }, null, -1 /* HOISTED */))
const _hoisted_37 = { class: "bar-legend" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "proposal-container",
    onClick: $setup.showDetailsClick
  }, [
    ($setup.showChartTooltip)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tooltip-chart",
          style: _normalizeStyle('top:' + $setup.tooltipPosY + 'px; left:'+ $setup.tooltipPosX + 'px; border-color:'+$setup.tooltipBorderColor)
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS." + $setup.tooltipOption)), 1 /* TEXT */),
          _createElementVNode("span", null, [
            _createElementVNode("b", null, _toDisplayString($setup.tooltipValue), 1 /* TEXT */)
          ])
        ], 4 /* STYLE */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, "#" + _toDisplayString($props.proposal.proposalId), 1 /* TEXT */),
      ($props.proposal.status == 'PROPOSAL_STATUS_VOTING_PERIOD')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Icon, {
              name: $setup.icons.get($props.proposal.status)
            }, null, 8 /* PROPS */, ["name"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW."+$props.proposal.status)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($props.proposal.status == 'PROPOSAL_STATUS_REJECTED')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              name: $setup.icons.get($props.proposal.status)
            }, null, 8 /* PROPS */, ["name"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW."+$props.proposal.status)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($props.proposal.status == 'PROPOSAL_STATUS_PASSED')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              name: $setup.icons.get($props.proposal.status)
            }, null, 8 /* PROPS */, ["name"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW."+$props.proposal.status)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($props.proposal.status == 'PROPOSAL_STATUS_DEPOSIT_PERIOD')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Icon, {
              name: $setup.icons.get($props.proposal.status)
            }, null, 8 /* PROPS */, ["name"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW."+$props.proposal.status)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      ($props.proposal.status == 'PROPOSAL_STATUS_FAILED')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Icon, {
              name: $setup.icons.get($props.proposal.status)
            }, null, 8 /* PROPS */, ["name"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("GOVERNANCE_VIEW."+$props.proposal.status)), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createElementVNode("h5", _hoisted_9, _toDisplayString($setup.getTitle()), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createVNode($setup["DateCommon"], {
              date: $props.proposal.isDepositPeriod() ? $props.proposal.submitTime : $props.proposal.votingStartTime
            }, null, 8 /* PROPS */, ["date"])
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString($props.proposal.isDepositPeriod() ? _ctx.$t("GOVERNANCE_VIEW.SUBMIT_TIME") : _ctx.$t("GOVERNANCE_VIEW.VOTING_START")), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", null, [
            _createVNode($setup["DateCommon"], {
              date: $props.proposal.isDepositPeriod() ? $props.proposal.depositEndTime : $props.proposal.votingEndTime
            }, null, 8 /* PROPS */, ["date"])
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString($props.proposal.isDepositPeriod() ? _ctx.$t("GOVERNANCE_VIEW.DEPOSIT_END_TIME") : _ctx.$t("GOVERNANCE_VIEW.VOTING_END")), 1 /* TEXT */)
        ])
      ])
    ]),
    ($props.proposal.status !== $setup.ProposalStatus.DEPOSIT_PERIOD)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bottom",
          onMousemove: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateTooltipPosition($event)))
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.showTooltip('YES', ''))),
                onMouseout: $setup.hideTooltip,
                class: "yes",
                style: _normalizeStyle('flex-basis:' + $setup.yesPercentageChart * 100 + '%')
              }, null, 36 /* STYLE, NEED_HYDRATION */),
              _createElementVNode("div", {
                onMouseover: _cache[1] || (_cache[1] = ($event: any) => ($setup.showTooltip('ABSTAIN', ''))),
                onMouseout: $setup.hideTooltip,
                class: "abstain",
                style: _normalizeStyle('flex-basis:' + $setup.abstainPercentageChart * 100 + '%')
              }, null, 36 /* STYLE, NEED_HYDRATION */),
              _createElementVNode("div", {
                onMouseover: _cache[2] || (_cache[2] = ($event: any) => ($setup.showTooltip('NO', ''))),
                onMouseout: $setup.hideTooltip,
                class: "no",
                style: _normalizeStyle('flex-basis:' + $setup.noPercentageChart * 100 + '%')
              }, null, 36 /* STYLE, NEED_HYDRATION */),
              _createElementVNode("div", {
                onMouseover: _cache[3] || (_cache[3] = ($event: any) => ($setup.showTooltip('NO_WITH_VETO', ''))),
                onMouseout: $setup.hideTooltip,
                class: "no-with-veto",
                style: _normalizeStyle('flex-basis:' + $setup.noWithVetoPercentageChart * 100 + '%')
              }, null, 36 /* STYLE, NEED_HYDRATION */),
              _createElementVNode("div", {
                onMouseover: _cache[4] || (_cache[4] = ($event: any) => ($setup.showTooltip('NOT_VOTED', ''))),
                onMouseout: $setup.hideTooltip,
                class: "not-voted",
                style: _normalizeStyle('flex-basis:' + $setup.notVotedPercentageChart * 100 + '%')
              }, null, 36 /* STYLE, NEED_HYDRATION */),
              _createCommentVNode(" <v-chart :option=\"option\" /> ")
            ]),
            _createElementVNode("div", {
              onMouseover: _cache[5] || (_cache[5] = ($event: any) => ($setup.showTooltip('THRESHOLD', $setup.thresholdPercentage.toFixed(2) + '%'))),
              style: _normalizeStyle({'left':$setup.thresholdPercentagePosition+'%'}),
              onMouseout: $setup.hideTooltip,
              class: "pin"
            }, [..._hoisted_20], 36 /* STYLE, NEED_HYDRATION */),
            _createElementVNode("div", {
              onMouseover: _cache[6] || (_cache[6] = ($event: any) => ($setup.showTooltip('QUORUM', $setup.quorumPercentage.toFixed(2)  + '%'))),
              style: _normalizeStyle({'left':$setup.quorumPercentage+'%'}),
              onMouseout: $setup.hideTooltip,
              class: "pin"
            }, [..._hoisted_24], 36 /* STYLE, NEED_HYDRATION */)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.YES")), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, [
                    _createVNode($setup["PercentsView"], {
                      amount: $setup.yesPercentage,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ])
                ]),
                _createCommentVNode("            (<CoinAmount :amount=\"useProposalsStore().getProposalTally(proposal).yes\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
                _createTextVNode(" ("),
                _createVNode($setup["CoinAmount"], {
                  amount: new $setup.BigIntWrapper($setup.yes),
                  "reduce-big-number": true,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"]),
                _createTextVNode(") ")
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.ABSTAIN")), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, [
                    _createVNode($setup["PercentsView"], {
                      amount: $setup.abstainPercentage,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ])
                ]),
                _createCommentVNode("            (<CoinAmount :amount=\"useProposalsStore().getProposalTally(proposal).abstain\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
                _createTextVNode(" ("),
                _createVNode($setup["CoinAmount"], {
                  amount: new $setup.BigIntWrapper($setup.abstain),
                  "reduce-big-number": true,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"]),
                _createTextVNode(") ")
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.NO")), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, [
                    _createVNode($setup["PercentsView"], {
                      amount:  $setup.noPercentage,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ])
                ]),
                _createCommentVNode("            (<CoinAmount :amount=\"useProposalsStore().getProposalTally(proposal).no\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
                _createTextVNode(" ("),
                _createVNode($setup["CoinAmount"], {
                  amount: new $setup.BigIntWrapper($setup.no),
                  "reduce-big-number": true,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"]),
                _createTextVNode(") ")
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("GOVERNANCE_VIEW.VOTING_OPTIONS.NO_WITH_VETO")), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, [
                    _createVNode($setup["PercentsView"], {
                      amount: $setup.noWithVetoPercentage,
                      precision: 2
                    }, null, 8 /* PROPS */, ["amount"])
                  ])
                ]),
                _createCommentVNode("            (<CoinAmount :amount=\"useProposalsStore().getProposalTally(proposal).noWithVeto\" :reduce-big-number=\"true\" :precision=\"2\"/>)"),
                _createTextVNode(" ("),
                _createVNode($setup["CoinAmount"], {
                  amount: new $setup.BigIntWrapper($setup.noWithVeto),
                  "reduce-big-number": true,
                  precision: 2
                }, null, 8 /* PROPS */, ["amount"]),
                _createTextVNode(") ")
              ])
            ])
          ])
        ], 32 /* NEED_HYDRATION */))
      : _createCommentVNode("v-if", true)
  ]))
}